module.exports = __webpack_public_path__ + "static/media/console1.d7cf0d55.png";